export default __webpack_public_path__ + "static/media/11.2f62d123.jpg";